const CONFIG = {
  serviceName: 'DODA.webs',

  isLocal: process.env.NEXT_PUBLIC_ENV_STAGE === 'local',
  isDev: process.env.NEXT_PUBLIC_ENV_STAGE === 'dev',
  isProd: process.env.NEXT_PUBLIC_ENV_STAGE === 'prod',
}
export default CONFIG
